import { defineStore } from "pinia";
import { ref } from "vue";

export const useDialogStore = defineStore("dialog", () => {
  const isOpen = ref(false);
  const message = ref("");
  const confirmAction = ref(null);

  // Método para abrir o diálogo
  const openDialog = (msg, action) => {
    message.value = msg;
    confirmAction.value = action;
    isOpen.value = true;
  };

  // Método para fechar o diálogo
  const closeDialog = () => {
    isOpen.value = false;
  };

  // Método para confirmar a ação
  const confirm = () => {
    if (confirmAction.value) {
      confirmAction.value(); // Executa a ação confirmada
    }
    closeDialog();
  };

  return { isOpen, message, openDialog, closeDialog, confirm };
});
